<script lang="ts">
    import { link, useFocus } from "svelte-navigator";
    import { darkMode } from "./stores";
    import AddressBox from "./uielements/AddressBox.svelte";
    import { hrefButtonStyleClasses } from "./utils";
    const registerFocus = useFocus();

    let donationAddress = "ban_1hchsy8diurojzok64ymaaw5cthgwy4wa18r7dcim9wp4nfrz88pyrgcxbdt";
</script>

<div class="m-6 grow container mx-auto max-w-screen-md p-2">
    <span use:registerFocus class="hidden" />
    <img src="/assets/brand/logo.svg" alt="JungleTV" class="h-24" />
    <p class="mt-3 text-lg">
        <a href="/guidelines" use:link>Community guidelines</a> • <a href="/faq" use:link>FAQ</a> •
        <a href="/history" use:link>Play history</a>
    </p>
    <p class="mt-3">
        JungleTV is a video sharing website for the <a href="https://banano.cc" target="_blank" rel="noopener">
            Banano
        </a>
        community. Banano is a feeless, instant, environment-friendly cryptocurrency that's ripe for memes.
    </p>
    <p class="mt-3">
        On JungleTV, users can earn Banano by watching YouTube videos that are added by other users to a sort of
        continuously evolving playlist - the <strong>queue</strong>. The videos play in sync for everyone, making the
        experience similar to watching TV or a livestream.
    </p>
    <p class="mt-3">
        Before participating, make sure to read the
        <a href="/guidelines" use:link>guidelines for acceptable content and behavior</a>.
    </p>
    <p class="mt-3">
        You will have to spend some Banano to
        <a href="/enqueue" use:link>enqueue media</a>. How much you must spend is determined by factors like the amount
        of people watching and the length of the queue.
    </p>
    <p class="mt-3">
        The Banano spent to enqueue each piece of content is distributed among the JungleTV spectators who our fraud
        prevention monkeys deem sufficiently ripe. Make sure to
        <a href="/rewards/address" use:link> set your address to earn rewards</a>! If you watch enough media, you'll
        eventually make enough to enqueue your own - or to recover your initial spending!
    </p>
    <hr class="mt-3" />
    <h3 class="mt-3 text-large font-semibold">Get in touch</h3>
    <p>
        JungleTV is a non-profit hobby project operated by Banano community members. You can discuss JungleTV in its
        dedicated
        <a href="https://chat.banano.cc/" target="_blank" rel="noopener">Banano Discord</a> channel.
    </p>
    <h3 class="mt-3 text-large font-semibold">Contribute</h3>
    <p>
        If you would like to help support the development and operation of JungleTV, consider donating some potassium to
        the address below:
    </p>
    <div class="mt-1">
        <AddressBox
            address={donationAddress}
            allowQR={true}
            qrCodeBackground={$darkMode ? "#111827" : "#F3F4F6"}
            qrCodeForeground={$darkMode ? "#FFFFFF" : "#000000"}
        />
    </div>
    <p class="mt-3">
        JungleTV is source-available software licensed under the Apache License 2.0 with Commons Clause. Head over to
        the <a href="https://github.com/tnyim/jungletv" target="_blank" rel="noopener">JungleTV GitHub</a> to take a look
        at the source code, report issues, or to maybe even make some contributions of your own!
    </p>
    <hr class="mt-3" />
    <div class="my-5 flex justify-center">
        <a use:link href="/" class={hrefButtonStyleClasses()}>Watch JungleTV</a>
    </div>
</div>
